import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ManageApplicationsComponent } from './components/manage-applications/manage-applications.component';
// import { ModuleRoutingConstants } from '../../core/helpers/module-routing.constants';

const routes: Routes = [
    // in order to load application successfuly there must be value in store that is Guarded by AppReadyGuard
    // and ConsentGuard - if consent is missing, then no navigation in app works
    // see ConsentEffects.enableRedirectToErrorScreen$ also
    // see UrlParamsEffects.ssoAuthenticationError$
    { path: 'applications', component: ManageApplicationsComponent }

];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class ApplicationsRoutingModule {}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/applications-routing.module.ts